import * as React from "react";
import Grid from "@material-ui/core/Grid";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import CloseIcon from "@material-ui/icons/Close";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import "../../assets/css/project-creation-mytask.css";
import { AppSettings } from "../../configs";
import { SecureGateRoute, BreadCrumb } from "../../components";
import { SettingSessionTimeoutService } from "../../services";
import { msg } from "../../components/Notifications/MsgBox";
import UserServices from '../../services/UserServices';

const SettingSessionTimeoutRow = ({ item, onEdit, onClose, onChange, isReadonly }) => {
  const handleOnEdit = () => {
    if (typeof onEdit === "function") {
      onEdit(item);
    }
  };

  const handleOnClose = () => {
    if (typeof onEdit === "function") {
      onClose(item);
    }
  };

  const handleOnChange = (event) => {
    if (typeof onChange === "function") {
        onChange(item, event.target.value);
    }
  };

  return (
    <TableRow style={{ border: "2px solid #ffffff" }}>
      <TableCell>
        <Typography>{item.display}</Typography>
      </TableCell>
      <TableCell>
        <Grid container>
          <Grid item xs={7} style={{ paddingRight: 20 }}>
            {item.mode === "edit" ? (
              <TextField
                type="number"
                size="small"
                variant="outlined"
                fullWidth
                defaultValue={item.value}
                style={{ backgroundColor: "#ffffff" }}
                inputProps={{ style: { textAlign: "right" }, maxLength: 4 }}
                onChange={handleOnChange}
              ></TextField>
            ) : (
              <Typography align="right">{item.value}</Typography>
            )}
          </Grid>
          { isReadonly ? <Grid item xs={5}></Grid> : <Grid item xs={5}>
            {item.mode === "" ? (
              <IconButton
                aria-label="delete"
                size="small"
                onClick={handleOnEdit}
              >
                <EditOutlinedIcon fontSize="inherit" />
              </IconButton>
            ) : (
              <IconButton
                aria-label="delete"
                size="small"
                onClick={handleOnClose}
              >
                <CloseIcon fontSize="inherit" />
              </IconButton>
            )}
          </Grid>}
        </Grid>
      </TableCell>
    </TableRow>
  );
};

const SettingSessionTimeoutScreen = () => {
  const [openLoading, setOpenLoading] = React.useState(false);
  const [items, setItems] = React.useState([]);
  const [tempItems, setTempItems] = React.useState([]);
  const [show, setShow] = React.useState(true);
  const [appReadonly,setAppReadonly] = React.useState(true);

  const initial = () => {
    setOpenLoading(true);
    SettingSessionTimeoutService.getItems()
      .then((response) => {
        setOpenLoading(false);

        if (response.success) {
          setItems(response.data.map((item) => ({ ...item, mode: "" })));
          setTempItems(response.data.map((item) => ({ ...item, mode: "" })));
        } else {
          msg.error(response.message);
        }
      })
      .catch((error) => {
        msg.error("Network error.");
        setOpenLoading(false);
      });
  };

  const handleOnSaveConfirm = () => {
    msg.showConfirm("Confirm", "Confirm กำหนด Session Timeout",()=>{
        msg.hideConfirm()
        handleOnSave();
    },() => {
        msg.hideConfirm()
    })
  }

  const handleOnSave = () => {
    setOpenLoading(true);
    SettingSessionTimeoutService.UpdateSessionTimeout(items).then(response=> {
        if (response.success) {
            initial();
          } else {
            setOpenLoading(false);
            msg.error(response.message);
          }
    }).catch((error) => {
        msg.error("Network error.");
        setOpenLoading(false);
      });
  };

  const handleOnEdit = (item) => {
    console.log("item", item);
    setItems((previous) => {
      return previous.map((ele) => {
        if (ele.id === item.id) {
          return { ...ele, mode: "edit" };
        } else {
          return ele;
        }
      });
    });
  };

  const handleOnChange = (item, v) => {
   
    setItems((previous) => {
      return previous.map((ele) => {
        if (ele.id === item.id) {
          return { ...ele, value: v };
        } else {
          return ele;
        }
      });
    });
  };

  const handleOnClose = (item) => {
    setItems((previous) => {
      return previous.map((ele) => {
        if (ele.id === item.id) {
            return tempItems.find(p=> p.id === item.id)
        } else {
          return ele;
        }
      });
    });
  };

  function IsShowsLoading(props) {
    const { isLoading } = props;
    return isLoading ? (
      <div id="loading-element">
        <div id="loading-indicator">
          <div className="lds-ripple">
            <div></div>
            <div></div>
          </div>
        </div>
      </div>
    ) : null;
  }

   const handleApplicationCheckReadonly = async () =>
    {
        UserServices.ApplicationReadonly().then(response=>{
            if(response.data === false)
            {
                setAppReadonly(false)
            }
        })
    }

  React.useEffect(() => {
    initial();
    handleApplicationCheckReadonly();
  }, []);

  return (
    <div className="tor tor-template-list">
      <IsShowsLoading isLoading={openLoading}></IsShowsLoading>
      <SecureGateRoute />
      <div id="main-content">
        <div className="page-body">
          <BreadCrumb
            breadcrumb={[
              { name: "RRS Home", url: AppSettings.defaultUrl },
              { name: "กำหนด Session Timeout", url: "" },
            ]}
          ></BreadCrumb>

          <div className="sp-page-header-panel row">
            <div className="col-md-5 sp-page-header">
              <h1 className="sp-page-header1">กำหนด Session Timeout</h1>
            </div>
          </div>

          <div className="sp-page-result-container">
            <div className="rrs-detail2">
              <div className="sp-table-container">
                <div className="row no-gutters sp-table-content">
                  <Accordion
                    expanded={show}
                    onChange={() => setShow((previous) => !previous)}
                    style={{
                      width: "100%",
                      backgroundColor: "#ddebf6",
                    }}
                    IconButtonProps={{}}
                  >
                    <AccordionSummary
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <ExpandMoreIcon
                        style={{
                          transform: show ? "rotate(360deg)" : "rotate(270deg)",
                          transition: "transform 150ms",
                        }}
                      />
                      <Typography>กำหนด SessionTimeout</Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Table
                        size="small"
                        style={{
                          backgroundColor: "#f2f2f2",
                          border: "2px solid #ffffff",
                        }}
                      >
                        <TableHead>
                          <TableRow style={{ border: "2px solid #ffffff" }}>
                            <TableCell>
                              <Typography align="center">
                                กรณี Session Timeout
                              </Typography>
                            </TableCell>
                            <TableCell>
                              <Typography align="center">
                                ระยะเวลา (นาที)
                              </Typography>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {items.map((item, i) => (
                            <SettingSessionTimeoutRow
                              item={item}
                              key={"sesstion-item-" + i}
                              onEdit={handleOnEdit}
                              onClose={handleOnClose}
                              onChange={handleOnChange}
                              isReadonly={appReadonly}
                            ></SettingSessionTimeoutRow>
                          ))}
                        </TableBody>
                      </Table>
                    </AccordionDetails>
                  </Accordion>
                  <Grid container>
                    { appReadonly === false && <Grid item xs={12} align="right" >
                      <Button
                        color="primary"
                        variant="contained"
                        startIcon={<SaveOutlinedIcon></SaveOutlinedIcon>}
                        onClick={handleOnSaveConfirm}
                      >
                        {" "}
                        Save
                      </Button>
                    </Grid>}
                  </Grid>
                 
                </div>
              </div>
            </div>
          </div>
          {/* <DetailBotLogModal /> */}
        </div>
      </div>
    </div>
  );
};

export default SettingSessionTimeoutScreen;
